export const GET_COMPANY = 'store/company/GET_COMPANY'



// WEBPACK FOOTER //
// ./src/actionTypes/Company/Company.js